<template>
  <section class="ut-autorizaciones">
    <h3>Autorizaciones de reimpresion</h3>
    <table><thead><tr><th>Ticket</th><th>Caja</th><th v-if="puedeQuitar"></th></tr></thead>
      <tbody><tr v-for="fila in datos.filas" :key="fila.id"><td>{{ fila.ticket }}</td><td>{{ fila.nombre_caja }} ({{ fila.caja }})</td>
        <td v-if="puedeQuitar"><v-btn icon small :disabled="disabled" :aria-label="'Quitar autorizacion de caja ' + fila.caja" title="Quitar autorizacion" @click="$emit('quitar', fila)"><v-icon small>mdi-delete-outline</v-icon></v-btn></td>
      </tr><tr v-if="!datos.filas.length"><td :colspan="puedeQuitar ? 3 : 2">Sin autorizaciones registradas.</td></tr></tbody>
    </table>
    <div v-if="datos.total > datos.tamano" class="ut-autorizaciones-paginas">
      <v-btn icon small :disabled="disabled || datos.pagina <= 1" title="Autorizaciones anteriores" @click="$emit('pagina', datos.pagina - 1)"><v-icon>mdi-chevron-left</v-icon></v-btn>
      <span>{{ datos.pagina }} / {{ Math.ceil(datos.total / datos.tamano) }}</span>
      <v-btn icon small :disabled="disabled || datos.pagina * datos.tamano >= datos.total" title="Autorizaciones siguientes" @click="$emit('pagina', datos.pagina + 1)"><v-icon>mdi-chevron-right</v-icon></v-btn>
    </div>
  </section>
</template>
<script>
export default { name: 'AutorizacionesTicket', props: { datos: { type: Object, required: true }, disabled: Boolean, puedeQuitar: Boolean } };
</script>
<style scoped>
.ut-autorizaciones { padding: 16px 24px; border-top: 1px solid #d5dce1; }
.ut-autorizaciones h3 { font-size: 14px; margin: 0 0 12px; }
.ut-autorizaciones table { width: 100%; border-collapse: collapse; font-size: 13px; }
.ut-autorizaciones td, .ut-autorizaciones th { text-align: left; padding: 8px; border-bottom: 1px solid #d8e0e6; overflow-wrap: anywhere; }
.ut-autorizaciones-paginas { display: flex; justify-content: flex-end; align-items: center; gap: 8px; }
</style>
